import {BaseModel} from '../base';
import {BBModel} from '../../bb_model';

/**
 * @description
 * A class that defines a service item in a basket.
 *
 */

class ServiceItemModel extends BaseModel {
    constructor(data, scope) {
        super(data);
        
        if (data) {
            if (data.company_id) {
                this.company_id = data.company_id;
            }
    
            if (data.duration) {
                this.duration = data.duration;
            }
    
            if (data.start) {
                this.datetime = moment(data.start);
            }

            if (data.expires) {
                this.expires = moment(data.expires);
            }
            
            this.promises = [];

            if (data.$has('service')) {
                const service = data.$get('service');
                this.promises.push(service);
                service.then((service) => {
                        return this.setService(new BBModel.Service(service), data.questions);
                    }
                );
            }

            if (data.$has('person')) {
                const person = data.$get('person');
                this.promises.push(person);
                person.then((person) => {
                        return this.setPerson(new BBModel.Person(person));
                    }
                );
            }

            if (data.$has('resource')) {
                const resource = data.$get('resource');
                this.promises.push(resource);
                resource.then((resource) => {
                        return this.setResource(new BBModel.Resource(resource));
                    }
                );
            }
        }

    }

    /**
     * @description
     * Get Post Data
     *
     * @returns {object}
     */
    getPostData() {
        const post = {
            company_id: this.company.id,
            service_id: this.service.global_id || this.service.id,
            start: this.start
        };

        if (this.resource) {
            post.resource_id = this.resource.id; 
        }

        if (this.person) {
            post.person_id = this.person.id; 
        }

        if (this.duration) {
            post.duration = this.duration;
        }

        if (this.item_details && this.asked_questions) {
            post.questions = this.item_details.getPostData();
        }

        return post;
    }
    

    setCompany(company) {
        this.company = company;
    }

    setService(service, default_questions, params) {
        this.service = service;

        let prom;
        if (default_questions == null) {
            default_questions = null;
        }

        if (this.service.$has('questions')) {
            this.has_questions = true;

            if (this.item_details) {
                this.item_details = null;
            }
            const no_cache = params ? params.no_cache : false;
    
            // we have a questions link - but are there actaully any questions ?
            prom = this.service.$get('questions', {no_cache});
            // this.promises.push(prom);
            prom.then((details) => {
                    if (this.company) {
                        details.currency_code = this.company.currency_code;
                    }
                    this.item_details = new BBModel.ItemDetails(details);
                    this.has_questions = this.item_details.hasQuestions;
                    if (default_questions) {
                        this.item_details.setAnswersFromQuestions(default_questions);
                        return this.setAskedQuestions();
                    }
                }  // make sure the item knows the questions were all answered
                , (err) => {
                    return this.has_questions = false;
                }
            );
    
        } else {
            this.has_questions = false;
        }
    }

    /**
     * @description
     * Set asked questions
     *
     * @returns {object} The returned set asked questions
     */
    setAskedQuestions() {
        this.asked_questions = true;
    }

    setPerson(person) {
        this.person = person ? person : true;
    }

    setResource(resource) {
        this.resource = resource ? resource : true;
    }

    setSlot(slot) {
        this.time = slot;
        if (slot && slot.start) {
            this.setStartTime(slot.start);
        }

        this.setDateTime();

    }

    setDuration(duration) {
        this.duration = duration;
    }

    setDateTime() {
        this.datetime = moment(this.start);
    }

    setStartTime(start) {
        this.start = start;
    }

    /**
     * @description
     * Verify type of any person
     *
     * @returns {boolean} The returned any person
     */
    anyPerson() {
        return this.person && (typeof this.person === 'boolean');
    }

    /**
     * @description
     * Verify type of any resorce
     *
     * @returns {boolean} The returned any resource
     */
    anyResource() {
        return this.resource && (typeof this.resource === 'boolean');
    }

    /**
     * @description
     * Get quantity of tickets
     *
     * @returns {integer} The returned quatity of tickets
     */
    getQty() {
        if (this.qty) {
            return this.qty;
        }
        if (this.tickets) {
            return this.tickets.qty;
        }
        return 1;
    }

    /**
     * @description
     * Set price in according of nprice parameter
     *
     * @returns {integer} The returned set price
     */
    setPrice(nprice) {
        let printed_price;
        if (nprice != null) {
            this.price = parseFloat(nprice);
            printed_price = this.price / 100;
            this.printed_price = (printed_price % 1) === 0 ? `£${parseInt(printed_price)}` : sprintf('£%.2f', printed_price);
            if (this.company && this.company.settings) {
                this.printed_vat_cal = this.company.settings.payment_tax;
            }
            if (this.printed_vat_cal) {
                this.printed_vat = (this.printed_vat_cal / 100) * printed_price;
            }
            if (this.printed_vat_cal) {
                return this.printed_vat_inc = ((this.printed_vat_cal / 100) * printed_price) + printed_price;
            }
        } else {
            this.price = null;
            this.printed_price = null;
            this.printed_vat_cal = null;
            this.printed_vat = null;
            return this.printed_vat_inc = null;
        }
    }

}

export {
    ServiceItemModel
};

